import { useState, useEffect } from 'react';

function CookieConsentManager() {
  const [consentGiven, setConsentGiven] = useState(false);
  const [showCCPA, setShowCCPA] = useState(false);

  useEffect(() => {
    // Check consent status on mount
    const consent = localStorage.getItem('cookieconsent');
    
    if (consent === 'true') {
      setConsentGiven(true);
      
      // Show CCPA link after a delay
      setTimeout(() => setShowCCPA(true), 1000);
    }

    // Cleanup function to remove CCPA link on unmount
    return () => {
      const ccpaLink = document.getElementById('ccpa-link');
      if (ccpaLink) {
        ccpaLink.remove();
      }
    };
  }, []);

  const handleOpenPreferences = () => {
    // Open cookie consent preferences modal
    if (window.CookieConsent && window.CookieConsent.openPreferences) {
      window.CookieConsent.openPreferences();
    } else {
      console.warn('Cookie Consent library not loaded');
    }
  };

  const handleResetConsent = () => {
    // Reset consent and show popup again
    localStorage.removeItem('cookieconsent');
    setConsentGiven(false);
    
    if (window.CookieConsent && window.CookieConsent.renew) {
      window.CookieConsent.renew();
    }
  };

  if (!showCCPA) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {/* Cookie Settings Button */}
      <button
        onClick={handleOpenPreferences}
        className="bg-slate-900 text-white px-4 py-2 rounded-lg shadow-lg hover:bg-slate-800 transition-colors flex items-center gap-2"
        aria-label="Cookie Preferences"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.25 10.757a1 1 0 01-.356.257l-7 3A1 1 0 004 14.91l8.25 3.536a1 1 0 001.572-1.148L13.75 14.25a1 1 0 00-.356-.257l-4-1.714a1 1 0 11.788-1.838l7-3a1 1 0 000-1.84l-7-3z" />
        </svg>
        Cookie Settings
      </button>

      {/* CCPA Link - Only shown after consent is given */}
      {consentGiven && (
        <div className="mt-2">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handleOpenPreferences();
            }}
            className="text-sm text-gray-300 hover:text-white underline"
            id="ccpa-link-text"
          >
            Do Not Sell My Personal Information (CCPA)
          </a>
        </div>
      )}

      {/* Reset Consent Button - For users who want to change their mind */}
      <button
        onClick={handleResetConsent}
        className="mt-2 text-xs text-gray-400 hover:text-white underline"
      >
        Change Cookie Settings
      </button>
    </div>
  );
}

export default CookieConsentManager;
